import React, { useState, useEffect } from 'react'
import Table from '../../components/Table'
import SimpleCard from '../../components/templates/SimpleCard'
import rekapData from '../../data/rekapTransaksiDummy'

const RekapTransaksi = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sort: ''
  })

  useEffect(() => {
    // Simulate API loading
    setLoading(true)
    setTimeout(() => {
      setData(rekapData)
      setLoading(false)
    }, 500)
  }, [])

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }))
  }

  const handleLimitChange = (newLimit) => {
    setPagination(prev => ({ ...prev, limit: newLimit, page: 1 }))
  }

  const handleSortChange = (sortField) => {
    setPagination(prev => {
      const [currentField, currentDir] = (prev.sort || '').split('|')
      let newDir = 'asc'
      if (currentField === sortField && currentDir === 'asc') {
        newDir = 'desc'
      }
      return { ...prev, sort: `${sortField}|${newDir}` }
    })
  }

  const getProcessedData = () => {
    let processed = [...data]
    
    if (pagination.sort) {
      const [field, direction] = pagination.sort.split('|')
      processed.sort((a, b) => {
        const aVal = a[field]
        const bVal = b[field]

        if (field === 'startDate' || field === 'endDate') {
           const dateA = new Date(aVal)
           const dateB = new Date(bVal)
           return direction === 'asc' ? dateA - dateB : dateB - dateA
        }
        
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return direction === 'asc' ? aVal - bVal : bVal - aVal
        }
        
        const aStr = String(aVal).toLowerCase()
        const bStr = String(bVal).toLowerCase()
        
        if (aStr < bStr) return direction === 'asc' ? -1 : 1
        if (aStr > bStr) return direction === 'asc' ? 1 : -1
        return 0
      })
    }
    
    const start = (pagination.page - 1) * pagination.limit
    const end = start + pagination.limit
    return processed.slice(start, end)
  }

  const tableConfig = {
    columns: [
      { key: 'startDate', title: 'Tanggal Mulai', align: 'left', sortable: true },
      { key: 'endDate', title: 'Tanggal Selesai', align: 'left', sortable: true },
      { key: 'clientName', title: 'Nama Client', align: 'left', sortable: true },
      { key: 'clientCode', title: 'Kode Client', align: 'left', sortable: true },
      { key: 'totalTransactions', title: 'Total Transaksi', align: 'center', sortable: true },
      { 
        key: 'totalAmount', 
        title: 'Total Nominal', 
        align: 'right', 
        sortable: true,
        render: (val) => `Rp ${Number(val).toLocaleString('id-ID')}`
      },
      { 
        key: 'status', 
        title: 'Status', 
        align: 'center', 
        sortable: true,
        render: (val) => {
          let color = '#38b2ac'
          let bg = '#e6fffa'
          
          if (val === 'Pending') {
            color = '#ed8936'
            bg = '#fffaf0'
          } else if (val === 'Gagal') {
            color = '#f56565'
            bg = '#fff5f5'
          }
          
          return (
            <span style={{ 
              padding: '4px 8px', 
              borderRadius: '4px', 
              backgroundColor: bg,
              color: color,
              fontWeight: 'bold',
              fontSize: '0.85rem'
            }}>
              {val}
            </span>
          )
        }
      }
    ],
    withIndex: true,
    total: data.length,
    limit: pagination.limit,
    currentPage: pagination.page,
    showRender: true,
    pagination: true,
    loading: loading,
    sort: pagination.sort,
    collapse: false
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Rekap Transaksi</h1>
        <p className="page-subtitle">Daftar rekap transaksi per sesi</p>
      </div>
      
      <SimpleCard>
        <Table
          data={getProcessedData()}
          config={tableConfig}
          onChangePage={handlePageChange}
          onLimit={handleLimitChange}
          onSort={handleSortChange}
        />
      </SimpleCard>
    </div>
  )
}

export default RekapTransaksi